export default __webpack_public_path__ + "static/team-meeting-laptops@2x-da0110971455896fd3540876b2c7943b.webp";